<h1 mat-dialog-title>
        <span [translate]="'admin.entreprise.description.licence.import'"></span>
        <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content class="py-1">
        <licence-uploader
                (onDocumentUploaded)="onItemUploaded($event)">
        </licence-uploader>
</div>